"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nevadaCompareSystems = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const queries_1 = require("../nevada-shared/queries");
exports.nevadaCompareSystems = (0, graphql_tag_1.default) `
  query SystemCompareQuery($input: CompareSystemsInputType!) {
    user {
      systemCompare(input: $input) {
        ...CompareResults
      }
    }
  }
  ${queries_1.compareResultFragment}
`;
//# sourceMappingURL=queries.js.map